import { ErrorPage } from '@thisisdmg/tirecloud-patterns/v2';
import { ReactNode } from 'react';

export default function GenericErrorComponent({
  errorCode,
  errorMessage,
  errorDetails,
  actionButton,
}: {
  errorCode: [number, number, number];
  errorMessage: ReactNode | string;
  errorDetails?: ReactNode | string;
  actionButton: ReactNode;
}) {
  return (
    <div className="tw:h-1 tw:[min-height:inherit]">
      <ErrorPage
        code={errorCode}
        title={errorMessage}
        description={errorDetails}
        actionButtons={actionButton}
      />
    </div>
  );
}
